import { NBase } from './interface';
import {
    BASE_CHANGE_FIELD,
} from './actions.types';
import { baseReducer } from './constants';

export const base = (state: NBase.Reducer = baseReducer, action: NBase.Actions): NBase.Reducer => {
    switch (action.type) {
        case BASE_CHANGE_FIELD: {
            return {
                ...state,
                [action.payload.field]: action.payload.value
            }
        }
        default:
            return state;
    }
}